import { CandidaturaResponseType, CandidaturasCardListType } from '../../types';

import { FunctionComponent } from 'react';
import { ImageHandler } from '../../utils';
import { ItemCard } from '../../components';
import { useTranslation } from 'react-i18next';

const CandidaturasCardList: FunctionComponent<CandidaturasCardListType> = ({ candidaturas }) => {
  const { t } = useTranslation();
  return (
    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2">
      {candidaturas.map((candidatura: CandidaturaResponseType) => (
        <div className={'col'}>
          <ItemCard
            ImageSection={
              <div className={'p-2 d-inline-flex align-items-center justify-content-center gap-2'}>
                <ImageHandler
                  src={candidatura.foto.link}
                  alt={t('descricao_objeto.img_candidato', { nome_chapa: candidatura.nome_chapa })}
                  className="img-candidato img-frame"
                  withLabel
                />
                <ImageHandler
                  src={candidatura.foto_vice ? candidatura.foto_vice.link : ''}
                  alt={t('descricao_objeto.img_vice_candidato', { nome_chapa: candidatura.nome_chapa })}
                  className="img-vice img-frame ms-2"
                  noImageTitle={t('label.vice_sem_imagem')}
                  withLabel
                />
              </div>
            }
            header={`${candidatura.nome_chapa} #${candidatura.numero_chapa.toString().padStart(2, '0')}`}
            imgTop
          >
            {candidatura.descricao}
          </ItemCard>
        </div>
      ))}
    </div>
  );
};

export default CandidaturasCardList;
